import { ArrowLink } from "@components/ArrowLink"
import CollectionGrid from "@components/CollectionGrid"
import Footer from "@components/Footer"
import { useIntl } from "@components/Intl"
import { Box, Container } from "@components/Layout"
import SEO from "@components/SEO"
import { Paragraph, TitleXL } from "@components/Typography"
import { CbSingleCollectionCollections } from "@lib/kontent/models/CbSingleCollectionCollections"
import { CollectionSeparateItemsPage } from "@lib/kontent/models/CollectionSeparateItemsPage"
import React from "react"

interface Props {
  collection: CollectionSeparateItemsPage
}

const SeparateItems: React.FC<Props> = ({ collection }) => {
  const collectionBlocks = collection.collections_grid
    .value as any as CbSingleCollectionCollections[]
  const { messages } = useIntl()
  return (
    <>
      <SEO
        title={collection.seo__meta_title.value}
        description={collection.seo__meta_description.value}
        imageUrl={collection.seo__meta_image.value[0]?.url}
        urlKey={"separateItems"}
      />
      <Container
        mt={["5rem", "5rem", "6rem"]}
        pt={["4rem", "3rem"]}
        pb={"6rem"}
      >
        <Box display={["none", "block"]}>
          <ArrowLink
            variant="arrow-left"
            href={messages.navigation.collection.url}
            as={messages.navigation.collection.url}
          >
            {messages.navigation.collection.title}
          </ArrowLink>
        </Box>
        <Box maxWidth={"30rem"} py={4}>
          <TitleXL>{collection.title.value}</TitleXL>
          <Paragraph>{collection.intro_text.value}</Paragraph>
        </Box>
        <CollectionGrid items={collectionBlocks} />
      </Container>
      <Footer />
    </>
  )
}

export default SeparateItems
